export const useEnvConfig = () => {
  return {
    DEV_MODE: process.env.REACT_APP_DEV_MODE === "true",
    MAP_BOX_TOKEN: process.env.REACT_APP_MAP_BOX_TOKEN,
  };
};
